/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
// import './styles/css/payment.css';
import { Button, Input, Segment, Form, Container, Header, Checkbox, Popup, Grid, Icon } from 'semantic-ui-react';

class ACHPayment extends Component {
  constructor() {
    super();
    this.state = {
      //   open: false,
      //   value: ''
    }
  }
  handleChange = (e, { name, value }) => this.setState({ [name]: value }, console.log(this.state))
  selectType = (e) => {
    this.setState({ value: e.target.getAttribute('name') }, console.log(this.state))
  }

  handleSubmit = () => {
    const { shipments } = this.state

    this.setState({ shipments },
      console.log(this.state))
  }
  render() {
    const { node, open, ach, creditCard, payPal } = this.state
    const style = {
      container: {
        borderRadius: 0,
        // opacity: 0.7,
        // padding: '2em',
        // backgroundColor: '#394B59 !important',
      }
    }
    return (
      <div>
        <Segment padded='very' className="signup-form payment-container" raised>
          <Form onSubmit={this.handleSubmit}>
            <Header as='h1'>Payment Information</Header>
            <label className="basic-info-label">PAYPAL INFORMATION</label>
            <Container className="add-payment-container">
              <Form>
                <Form.Field>
                  <label className="basic-info-label">NAME ON ACCOUNT</label>
                  <Input placeholder='Enter Account Holder Name'
                    name="fullname"
                    // value={fullname}
                    className="basic-info-input"
                    onChange={this.handleChange.bind(this)}
                  />
                  <label className="basic-info-label">BANK NAME</label>
                  <Input placeholder='Enter Bank Name'
                    name="username"
                    // value={username}
                    className="basic-info-input"
                    onChange={this.handleChange.bind(this)}
                  />
                  <label className="basic-info-label">ACCOUNT NUMBER</label>
                  <Input placeholder='Enter Account Number'
                    name="password"
                    // value={password}
                    type="password"
                    className="basic-info-input"
                    onChange={this.handleChange.bind(this)}
                  />
                  <label className="basic-info-label">BANK ROUTING NUMBER</label>
                  <Input placeholder='Enter Bank Routing Number'
                    name="email"
                    // value={email}
                    type="email"
                    className="basic-info-input"
                    onChange={this.handleChange.bind(this)}
                  />
                  <label className="basic-info-label">BANK CITY / STATE</label>
                  <Input
                    placeholder='Enter Bank City / State'
                    name="phone"
                    // value={phone}
                    className="basic-info-input"
                    onChange={this.handleChange.bind(this)}
                  />
                  <br />
                </Form.Field>
              </Form>
              <br />
              <center>
                <Popup
                  // open={open}
                  trigger={<Icon onClick={this.toggle} name="add" circular color="blue" className="add-payment" size='big' />}
                  inverted
                  flowing hoverable content={<Checkbox />} size='tiny' position="top center" className="payment-popup" style={style.contiainer}
                >
                  <Grid divided columns={1} className="payment-popup-grid">
                    <Grid.Column>
                      <Form.Group>
                        <p onClick={this.selectType.bind(this)} name="ach" className="payment-popup-p"><Icon name="money bill alternate outline" />ACH</p>
                      </Form.Group>
                      <Form.Group>
                        <p onClick={this.selectType.bind(this)} name="credit card" className="payment-popup-p"><Icon name="credit card outline" />Credit Card</p>
                      </Form.Group>
                      <Form.Group>
                        <p onClick={this.selectType.bind(this)} name="paypal" className="payment-popup-p"><Icon name="cc paypal" />PayPal</p>
                      </Form.Group>
                    </Grid.Column>
                  </Grid>
                </Popup>
              </center>
            </Container>
          </Form>
          <div className="payment-buttonRow">
            <Button type='submit' className="payment-cancel">CANCEL</Button>
            <Button type='submit' className="payment-skip">SKIP THIS</Button>
            <Button type='submit' className="payment-save" color="twitter">SAVE & NEXT</Button>
          </div>
        </Segment>

        {/* </div> */}
      </div>
    );
  }
}

export default ACHPayment;
